function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2, .cls-4 {\r\n        fill: #5273e6;\r\n      }\r\n\r\n      .cls-3, .cls-4 {\r\n        stroke: none;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "TuTorial",
  transform: "translate(-1134 -70)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_172",
  "data-name": "Path 172",
  className: "cls-1",
  transform: "translate(1153.432 73.247)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M.649,1.948,9.092,0a.649.649,0,0,1,.649.649v9.742a.649.649,0,0,1-.649.649L.649,9.092A.649.649,0,0,1,0,8.443V2.6A.649.649,0,0,1,.649,1.948Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M 8.241825103759766 1.73570728302002 L 1.499995231628418 3.29151725769043 L 1.499995231628418 7.749222755432129 L 8.241825103759766 9.305032730102539 L 8.241825103759766 1.73570728302002 M 9.092374801635742 0 C 9.451054573059082 0 9.741825103759766 0.2907695770263672 9.741825103759766 0.6494503021240234 L 9.741825103759766 10.39128017425537 C 9.741825103759766 10.74997043609619 9.451054573059082 11.04074001312256 9.092374801635742 11.04074001312256 L 0.6494550704956055 9.09237003326416 C 0.2907752990722656 9.09237003326416 -4.76837158203125e-06 8.801599502563477 -4.76837158203125e-06 8.442919731140137 L -4.76837158203125e-06 2.597820281982422 C -4.76837158203125e-06 2.239139556884766 0.2907752990722656 1.948369979858398 0.6494550704956055 1.948369979858398 L 9.092374801635742 0 Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_173",
  "data-name": "Path 173",
  className: "cls-1",
  transform: "translate(1133 70)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M3,0H20.081a2,2,0,0,1,2,2V15.535a2,2,0,0,1-2,2H3a2,2,0,0,1-2-2V2A2,2,0,0,1,3,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M 3 1.499996185302734 C 2.724300384521484 1.499996185302734 2.5 1.724296569824219 2.5 1.999997138977051 L 2.5 15.53529644012451 C 2.5 15.81099700927734 2.724300384521484 16.03529739379883 3 16.03529739379883 L 20.08148002624512 16.03529739379883 C 20.35717964172363 16.03529739379883 20.58148002624512 15.81099700927734 20.58148002624512 15.53529644012451 L 20.58148002624512 1.999997138977051 C 20.58148002624512 1.724296569824219 20.35717964172363 1.499996185302734 20.08148002624512 1.499996185302734 L 3 1.499996185302734 M 3 -3.814697265625e-06 L 20.08148002624512 -3.814697265625e-06 C 21.18605041503906 -3.814697265625e-06 22.08148002624512 0.8954277038574219 22.08148002624512 1.999997138977051 L 22.08148002624512 15.53529644012451 C 22.08148002624512 16.63985633850098 21.18605041503906 17.53529739379883 20.08148002624512 17.53529739379883 L 3 17.53529739379883 C 1.895429611206055 17.53529739379883 1 16.63985633850098 1 15.53529644012451 L 1 1.999997138977051 C 1 0.8954277038574219 1.895429611206055 -3.814697265625e-06 3 -3.814697265625e-06 Z"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_55",
  "data-name": "Ellipse 55",
  className: "cls-2",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(1149.185 73.598)"
}));

var SvgVideo = function SvgVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29.174 17.535",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video.d89c9c5d.svg";
export { ForwardRef as ReactComponent };